export default __webpack_public_path__ + "static/media/timer-start-danger.b6ae0994.svg";